import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CalendarSquareRegularEventTypeIconSvg from './calendar-square-regular-event-type-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CalendarSquareRegularEventTypeIconSvg {...validProps} />;
}

SvgComponent.iconName = 'calendarSquareRegularEventType';

export const CalendarSquareRegularEventTypeIcon = svgIconWrapper(SvgComponent);
